import "./index.scss";

export const BrandCallToAction = ({
  title,
  description,
  buttonContent,
  onButtonClick
}) => {
  return (
    <div className="brand-call-to-action">
      <div className="content-container">
        <h3>{title}</h3>
        <p dangerouslySetInnerHTML={{ __html: description }}></p>
      </div>
      <div className="button-container">
        <button onClick={onButtonClick}>{buttonContent}</button>
      </div>
    </div>
  );
};
